module.exports = __webpack_public_path__ + "assets/img/AI赋能.41ffa3be.jpg";